import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  AddCandidateModalComponent,
  AddCandidateModalData,
} from '@shared/candidate/side-nav-candidate/components/talent-pool-add-candidate-modal/add-candidate-modal.component';
import { CandidateAdapter } from '@shared';
import { Store } from '@ngrx/store';
import {
  getCandidateTalentPoolsList,
  getCandidateTalentPoolsListPageNumber,
  getCandidateTalentPoolsListTotalPagesNumber,
  resetTalentPoolsForCandidateState,
  talentPoolsForCandidateLoad,
} from 'mojo-talent-pools';

@Component({
  selector: 'mojo-candidate-talent-pools',
  templateUrl: './candidate-talent-pools.component.html',
  styleUrls: ['./candidate-talent-pools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateTalentPoolsComponent implements OnDestroy {
  candidateId: number;
  @Input() set candidate(value: CandidateAdapter) {
    if (value.id) {
      this.candidateId = value.id;
      this.store.dispatch(talentPoolsForCandidateLoad({ id: value.id, page: 0 }));
    }
  }
  talentPools$ = this.store.select(getCandidateTalentPoolsList);
  talentPoolsPageNumber$ = this.store.select(getCandidateTalentPoolsListPageNumber);
  talentPoolsTotalPagesNumber$ = this.store.select(getCandidateTalentPoolsListTotalPagesNumber);

  constructor(private dialog: MatDialog, private store: Store) {}

  openModal() {
    this.dialog.open<AddCandidateModalComponent, AddCandidateModalData>(
      AddCandidateModalComponent,
      {
        panelClass: 'medium-size-modal',
        disableClose: true,
        data: {
          candidateIds: [this.candidateId],
          isSideDrawerAction: true,
        },
      },
    );
  }

  onScroll(page, totalPagesNumber) {
    const pageToSend = page + 1;
    if (pageToSend < totalPagesNumber) {
      this.store.dispatch(talentPoolsForCandidateLoad({ id: this.candidateId, page: pageToSend }));
    }
  }

  ngOnDestroy() {
    this.store.dispatch(resetTalentPoolsForCandidateState());
  }
}
